import { ShopSettings as ShopSettingsModule } from "../modules/ShopSettings/ShopSettings";

const ShopSettings = () => {
  return <ShopSettingsModule />;
};

export default ShopSettings;
